import type { FeatureState } from './typings'

import { generateEmptyPublicData } from '@/server-data'

export const initialState: FeatureState = {
  publicData: generateEmptyPublicData(),
  extendedOrderSteps: {},
  ordersGridRows: [],
}
